export enum DATA_QA {
  CANCEL = 'dnc-delete__cancel',
  CONFIRM = 'dnc-delete__confirm',
}
